import React from "react";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import FontIcon from "react-md/lib/FontIcons";
import Button from "react-md/lib/Buttons/Button";
import { map } from "lodash";
import {DebugElement} from "../../../Atollon/debug";

const Keys = ({ keys }) => {
  return (
    <DebugElement text={"src/components/settings/profile/Keys.js"}/>
  );
};

export default Keys;



// WEBPACK FOOTER //
// ./src/components/settings/profile/Keys.js